export default __webpack_public_path__ + "static/media/silverAward.24d3107e.svg";